// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"3981":"block0","9735":"block12"}[chunkId] + "." + {"3981":"f1da1030","9735":"289f6e5f"}[chunkId] + ".css";
};